import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TopNav = ({ title }) => {
  const navigate = useNavigate();
  const theme = useTheme(); // جلب الثيم الحالي (light أو dark)
  const { light } = useSelector((state) => state.theme); // جلب حالة الثيم من Redux

  // الرجوع إلى الصفحة السابقة
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: theme.palette.background.navbar, // لون الخلفية من الثيم
        color: theme.palette.text.primary, // لون النص من الثيم
        p: 2,
        boxShadow: light ? '0 2px 4px rgba(0, 0, 0, 0.1)' : '0 2px 4px rgba(0, 0, 0, 0.5)', // ظل خفيف يتغير بناءً على الثيم
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* أيقونة الرجوع */}
      <IconButton
        onClick={handleBack}
        sx={{
          color: theme.palette.text.primary,
          '&:hover': {
            bgcolor: light ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.08)',
          },
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      {/* العنوان */}
      <Typography variant="h6" sx={{ fontWeight: 'bold', flexGrow: 1, textAlign: 'center' }}>
        {title || 'App Name'} {/* يمكن تمرير عنوان مخصص كـ prop */}
      </Typography>

      {/* مساحة فارغة للحفاظ على التوازن */}
      <Box sx={{ width: 40 }} />
    </Box>
  );
};

export default TopNav;